import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import PolicyPicker from '../../../../components/PolicyPicker/PolicyPicker';
import _ from 'lodash';
import { Button } from '@mui/material';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

const ButtonStyle = {
  minWidth: 40,
  width: 40,
  height: 30,
  padding: '4px 6px',
  borderRadius: 6,
  lineHeight: 1
};

const EditIconStyle = {
  fontSize: 18
};

const PolicyPickerButton = props => {
  const { viewingClient, selectedPolicies, filter, onSubmit, ...rest } = props;

  const [open, setOpen] = useState(false);
  const openPicker = () => setOpen(true);
  const closePicker = () => setOpen(false);

  return (
    <Fragment>
      <Button
        className="policy-picker-button"
        variant="contained"
        color="primary"
        onClick={openPicker}
        style={ButtonStyle}
        size="small"
        disableElevation
      >
        <EditRoundedIcon style={EditIconStyle} />
      </Button>

      <PolicyPicker
        userId={_.get(viewingClient, '_id')}
        selectedPolicies={selectedPolicies}
        open={open}
        onClose={closePicker}
        filter={filter}
        onSubmit={onSubmit}
        {...rest}
      />
    </Fragment>
  );
};

const container = connect(
  state => ({
    viewingClient: state.client.viewingClient
  }),
  {}
)(PolicyPickerButton);

export default container;
